import React from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { ReactComponent as IconChattyLogo } from 'media/svg/chattyLogo.svg';
import { ReactComponent as IconStar } from 'media/svg/star.svg';

import { ChatBotData } from 'proto/ChatBotData';
import { Salutation } from 'proto/User/Salutation';

import styles from '../Card.module.scss';

export interface ChatProps {
    chatBot?: ChatBotData;
    customClass?: string;
}

const getSalutationKey = (salutation?: Salutation) => {
    switch (salutation) {
        case Salutation.Male:
            return 'TRANS-salutation-male';
        case Salutation.Female:
            return 'TRANS-salutation-female';
        default:
            return 'TRANS';
    }
};
const Chat = ({ chatBot, customClass = '' }: ChatProps) => {
    const { t } = useTranslation();

    const greeting =
        chatBot?.salutation && chatBot?.lastName
            ? `${t('TRANS-greeting-casual')} ${t(
                  getSalutationKey(chatBot?.salutation)
              )} ${chatBot?.lastName}, `
            : `${t('TRANS-greeting-casual')}, `;

    return (
        <div
            className={classNames(
                styles.Expert,
                customClass,
                'c24-travel-js-open-chatbot'
            )}
        >
            <div className={styles.BubbleWrapper}>
                <div className={styles.ChatBubble}>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t('TRANS-chat-greeting', {
                                greeting: greeting,
                                regionName: chatBot?.regionName,
                            }),
                        }}
                    />
                    <div className={`${styles.Link} chat-link`}>
                        {t('TRANS-start-chat-now')}
                    </div>
                </div>
            </div>
            <div className={styles.ImageWrapper}>
                <div className={styles.Icon}>
                    <IconChattyLogo />
                </div>
            </div>
            <div className={styles.Contact}>
                <div className={styles.Person}>
                    <div className={styles.Name}>{t('TRANS-chatty-name')}</div>
                    <span className={styles.Rating}>
                        {[...Array(Math.floor(5))].map((_, index) => {
                            return <IconStar key={index} />;
                        })}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Chat;
